module.exports = __webpack_public_path__ + "static/media/300dpi_Logo_Dark.a9f22752.png";